import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnDemandPsvButtonComponent } from 'components/on-demand-psv-button/on-demand-psv-button.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { OptionDropdownModule } from '@certemy/ui-components';
import { NgbCustomModalModule } from 'components/modal-windows/ngb-custom-modal/ngb-custom-modal.module';

@NgModule({
  declarations: [OnDemandPsvButtonComponent],
  imports: [CommonModule, NgbTooltipModule, OptionDropdownModule, NgbCustomModalModule],
  exports: [OnDemandPsvButtonComponent],
})
export class OnDemandPsvButtonModule {}
